import {
  dangerColor,
} from 'assets/jss/app.js'

const departmentSignaturesStyle = {
  dangerBackground: {
    backgroundColor: dangerColor[5]
  },
}

export default departmentSignaturesStyle
